import { planTypes } from "@/common/constants";

export const computedLargeMeetingPlans = plans => plans.filter(item => item.type === planTypes.LARGE_MEETING);
export const computedAnnualLargePlans = plans => computedLargeMeetingPlans(plans).filter(item => item.billing_cycle === 'annual');
export const computedMonthlyLargePlans = plans => computedLargeMeetingPlans(plans).filter(item => item.billing_cycle === 'monthly');
export const computedOneMonthLargePlans = plans => computedLargeMeetingPlans(plans).filter(item => item.billing_cycle === 'one_month');

export const computedLargeMeetingPlansByBillingCycle = (plans, billingCycle) => computedLargeMeetingPlans(plans).filter(item => item.billing_cycle === billingCycle);

export const computedCapacityLargePlans = (plans, capacity) => computedLargeMeetingPlans(plans).filter(item => item.participants === capacity);
